<template>
  <div id="app" class="h-screen">
    <loading ref="loading"/>

    <transition v-if="appLoaded" name="page" mode="out-in">
      <component :is="layout" v-if="layout"/>
    </transition>
  </div>
</template>

<script>
import Loading from './Loading';
import {mapState, mapGetters, mapActions} from 'vuex';

// Load layout components dynamically.
const requireContext = require.context('@/layouts', false, /.*\.vue$/);

const layouts = requireContext
  .keys()
  .map(file => [file.replace(/(^.\/)|(\.vue$)/g, ''), requireContext(file)])
  .reduce((components, [name, component]) => {
    components[name] = component.default || component
    return components
  }, {});

export default {
  el: '#app',

  components: {
    Loading
  },

  data: () => ({
    layout: null,
    defaultLayout: 'Main',
    appLoaded: false
  }),

  metaInfo() {
    return {
      title: this.tenantName,
      titleTemplate: `%s | ${this.tenantName}`,
    }
  },

  computed: {
    ...mapState('auth', {
      authChecked: state => state.checked
    }),

    ...mapGetters('civium', [
      'hasExperiment',
      'tenantName',
    ])
  },

  methods: {
    ...mapActions('civium', [
      'setTenantDetails',
      'fetchExperiment',
      'fetchScoreDetails',
    ]),
    ...mapActions('auth', [
      'setAuthed',
      'fetchUser',
    ]),

    /**
     * Set the application layout.
     *
     * @param {String} layout
     */
    setLayout(layout) {
      if (!layout || !layouts[layout]) {
        layout = this.defaultLayout;
      }

      this.layout = layouts[layout];
    },

    async loadApp() {
      try {
        if (this.authChecked) {
          await this.fetchUser();
          await this.fetchExperiment();

          if (this.hasExperiment) {
            this.fetchScoreDetails();
          }
        }
      } catch (error) {
      }

      this.appLoaded = true;
    }
  },

  mounted() {
    this.$loading = this.$refs.loading;
    this.loadApp();
  },

  async created() {
    await this.setAuthed({checked: window.config.authCheck});

    await this.setTenantDetails({
      name: window.config.appName,
      allowMultipleExperiments: window.config.allowMultipleExperiments,
    });
  }
}
</script>

